// extracted by mini-css-extract-plugin
module.exports = {"image-file":"DownloadRow_image-file__1lhVK","item-holder":"DownloadRow_item-holder__zT5u1","pointer":"DownloadRow_pointer__3jr_p"};